import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Home from "./views/Home";
import PrivacyPolicy from "./views/PrivacyPolicy";
import TermsConditions from "./views/TermsConditions";

Vue.use(Router);

export default new Router({

  linkExactActiveClass: "active",
  routes: [
    {
      path: "*",
      name: "main",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    {
      path: "/privacy_policy",
      name: "privacy_policy",
      components: {
        header: AppHeader,
        default: PrivacyPolicy,
        footer: AppFooter
      }
    },
    {
      path: "/terms_conditions",
      name: "terms_conditions",
      components: {
        header: AppHeader,
        default: TermsConditions,
        footer: AppFooter
      }
    },
    // {
    //   path: "/components",
    //   name: "components",
    //   components: {
    //     header: AppHeader,
    //     default: Components,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/landing",
    //   name: "landing",
    //   components: {
    //     header: AppHeader,
    //     default: Landing,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/login",
    //   name: "login",
    //   components: {
    //     header: AppHeader,
    //     default: Login,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/register",
    //   name: "register",
    //   components: {
    //     header: AppHeader,
    //     default: Register,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: {
    //     header: AppHeader,
    //     default: Profile,
    //     footer: AppFooter
    //   }
    // }
  ],
  // mode: 'history',
  scrollBehavior: to => {

    console.log('to',to);

    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.getElementById(to.hash.substring(1));
          console.log("element ",element);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
          resolve();
        }, 500); // 調整延遲時間以確保元素正確載入
      });
      // return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
